module.exports = __webpack_public_path__ + "static/media/gustavo@3x.96166055.jpg";